export default "__VITE_ASSET__DYfd$RGh__"